<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-map-pin" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">{{ clients.length }} LGA Users/Facilities</h4>
              <small style="opacity: .8;">Enrollees and facilities within this Local Government Area</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-users text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">LGA Users / Facilities</h6>
            <span class="badge badge-soft-info ml-2">{{ clients.length }}</span>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Name</th>
                  <th class="table-th">Contact</th>
                  <th class="table-th">Status</th>
                  <th class="table-th">Type</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="enrollee in clients" v-bind:key="enrollee.id">
                  <td class="font-weight-bold">
                    {{ enrollee.firstname }} {{ enrollee.lastname }} {{ enrollee.agency_name }}
                  </td>
                  <td>{{ enrollee.phone_number }}</td>
                  <td>
                    <span class="badge badge-soft-secondary">{{ enrollee.sector }}</span>
                  </td>
                  <td>{{ enrollee.type }}</td>
                  <td>
                    <router-link :to="{ path: '/client/' + enrollee.id }" v-if="enrollee.type == 'client'">
                      <button type="button" name="button" class="btn btn-sm btn-outline-secondary">
                        <i class="fe fe-eye"></i>
                      </button>
                    </router-link>
                  </td>
                </tr>
                <tr v-if="!clients.length">
                  <td colspan="5" class="text-center py-5 text-muted">
                    <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                    <p class="mt-2 mb-0">No users/facilities found</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Navbar, Loading
  },
  data(){
    return{
      user:null,
      clients:"",
      edit:false,
      isLoading: false,
      fullPage: true,
      agency_id:""
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/getuserbylga/${this.$route.params.id}`)
                .then(response => {
                    this.clients = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{
    getUsers(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/getuserbylga/${this.$route.params.id}`)
                  .then(response => {
                      this.clients = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    }

  },
  created(){
    // this.getUsers()
  }

}
</script>
<style >
.spacer{
  margin-left:15px;
}
</style>
